import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../hooks/useApi";
import { authenticationActions } from "../../store/authentication";
import { errorActions } from "../../store/error";

/**
 * AuthInterceptorProvider sets up axios interceptor for 401/403 errors
 * Must be wrapped inside Router and Redux Provider for useNavigate and useDispatch to work
 */
const AuthInterceptorProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Add response interceptor for 401/403 errors on the shared axiosInstance
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          // Authentication or authorization failed
          console.warn(
            `Authentication failed with status ${error.response.status}`,
          );

          // Clear authentication state
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          localStorage.removeItem("email");

          // Dispatch logout action to clear Redux state
          dispatch(authenticationActions.logout());

          // Show user-friendly message
          dispatch(
            errorActions.setError({
              message: "Your session has expired. Please log in again.",
              severity: "warning",
            }),
          );

          // Redirect to login
          navigate("/login");
        }
        // Re-throw error for calling code to handle
        return Promise.reject(error);
      },
    );

    // Cleanup interceptor on unmount
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [dispatch, navigate]);

  return children;
};

export default AuthInterceptorProvider;
